module.exports = __webpack_public_path__ + "assets/1bbdfcde60f3c01e5898e3f495c9ea9e.svg";